/**
 * 拖动排序公共组件  by xcc
 */
import React from 'react';
import {message, Modal, Spin} from "antd";
import BaseComponent from "../../base/BaseComponent";
import DragSortTable from "./DragSortTable";

export default class DragSort extends BaseComponent {
    static propTypes = {};
    static defaultProps = {
        title: "拖动排序",
        orderField: "sort"
    };

    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            spinning: false,
            mediaId: props.mediaId,
            treeContentId: props.treeContentId,
        }
    }

    componentWillMount() {
    }

    componentDidMount() {

    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            mediaId: nextProps.mediaId,
            treeContentId: nextProps.treeContentId
        })
    }

    showSortModal = () => {
        this.setState({
            visible: true
        });
    };

    handleOk = () => {
        this.setState({
            spinning: true
        });
        let that = this;
        let sortIds = [];
        let sortFields = [];
        let newSortList = this.columnSortTable.state.sortList;
        newSortList.forEach((item, index) => {
            sortIds.push(item.id);
            sortFields.push(item.sort);
        });
        let params = {
            columnIds: sortIds.toString(),
            sorts: sortFields.toString(),
        };
        this.request({
            url: "/cm-sites-mmp/column/updateSort",
            body: params,
            method: "get",
            contentType: "json",
            callBack: (res) => {
                message.success("排序成功", 2, function () {
                    that.setState({
                        visible: false,
                        spinning: false
                    })
                    that.props.refreshList();
                });
            }
        });
    }

    handleCancel = () => {
        this.setState({
            visible: false
        });
    };

    render() {
        let {title, orderField} = this.props;
        let {visible, mediaId, treeContentId} = this.state;
        return (
            <Modal
                title={title}
                visible={visible}
                onOk={this.handleOk}
                onCancel={this.handleCancel}
                destroyOnClose={true}
                maskClosable={false}
                width={"65%"}
            >
                <Spin spinning={this.state.spinning}>
                    <DragSortTable mediaId={mediaId} treeContentId={treeContentId} orderField={orderField}
                                   ref={(columnSortTable) => this.columnSortTable = columnSortTable}/>
                </Spin>
            </Modal>
        )
    }
}